import { render } from "./LessonsFilter.vue?vue&type=template&id=70f78752&ts=true"
import script from "./LessonsFilter.vue?vue&type=script&lang=ts"
export * from "./LessonsFilter.vue?vue&type=script&lang=ts"

import "./LessonsFilter.vue?vue&type=style&index=0&id=70f78752&lang=css"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__